import Vue from 'vue';
import Router from 'vue-router';

// import Dashboard from '@/components/Dashboard.vue';
import BillRun from '@/components/BillRun.vue';
import BillRunOH from '@/components/BillRunOH.vue';
import Login from '@/components/Login.vue';
import PaymentRun from '@/components/PaymentRun.vue';
import LandingPage from '@/components/LandingPage.vue';
import ReleasesPage from '@/components/ReleasesPage.vue';
import CollectionRun from '@/components/CollectionRun.vue';
// import SignUpLogs from '@/components/SignUpLogs.vue';
import StatementsOH from '@/components/StatementsOH.vue';
import ETs from '@/components/ETs.vue';
import OnHoldRules from '@/components/OnHoldRules';

import {
  AuthPlugin,
  AuthDriver
} from '@/auth';

import { addBrandingRoutes } from './branding.js';

global.$ = global.jQuery = require('jquery');

$.getJSON("/appsettings.json", function (json) {
  Vue.config.honeycomb = json;
  Vue.use(Router);
  Vue.use(AuthPlugin, {
    authStyles: {
      'OnPremise': new AuthDriver({
        SCOPE: Vue.config.honeycomb.auth.scope,
        CLIENT_ID: Vue.config.honeycomb.auth.clientId,
        REDIRECT_URI: Vue.config.honeycomb.auth.redirect,
        SLUG: Vue.config.honeycomb.auth.slug
      }),
      'Remote': new AuthDriver({
        SCOPE: Vue.config.honeycomb.auth.scope,
        CLIENT_ID: Vue.config.honeycomb.auth.clientId,
        REDIRECT_URI: Vue.config.honeycomb.auth.redirect,
        SLUG: Vue.config.honeycomb.auth.slug,
        PROVIDER: Vue.config.honeycomb.auth.providerId
      }),
      'RB': new AuthDriver({
        SCOPE: Vue.config.honeycomb.auth.scope,
        CLIENT_ID: Vue.config.honeycomb.auth.clientId,
        REDIRECT_URI: Vue.config.honeycomb.auth.redirect,
        SLUG: Vue.config.honeycomb.auth.slug,
        PROVIDER: Vue.config.honeycomb.auth.providerId
      })
    },
    baseURL: Vue.config.honeycomb.auth.base
  })
})

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      props: { authStyle: 'OnPremise' },
    },
    {
      path: '/login/remote',
      name: 'remoteLogin',
      component: Login,
      props: { authStyle: 'Remote' },
    },
    {
      path: '/login/rb',
      name: 'rbLogin',
      component: Login,
      props: { authStyle: 'RB' },
    },
    {
      path: '/',
      name: 'landingPage',
      component: LandingPage,
      meta: { requiresAuth: true },
    },
    {
      path: '/releases',
      name: 'releasesPage',
      component: ReleasesPage,
      meta: { requiresAuth: true },
    },
    {
      path: '/dashboard/:customerRef',
      name: 'dashboard',
      // component: Dashboard,
      component: () => import('@/components/Dashboard.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/bill',
      name: 'billRun',
      component: BillRun,
      // component: () => import('@/components/BillRun.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/billOH',
      name: 'billRunOH',
      component: BillRunOH,
      meta: { requiresAuth: true },
    },
    {
      path: '/payment',
      name: 'paymentRun',
      component: PaymentRun,
      meta: { requiresAuth: true },
    },
    {
      path: '/collection',
      name: 'collectionRun',
      component: CollectionRun,
      meta: { requiresAuth: true },
    },
    {
      path: '/sign-up-logs',
      name: 'signUpLogs',
      // component: SignUpLogs,
      component: () => import('@/components/SignUpLogs.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/arudd-processing-logs',
      name: 'aruddProcessingLogs',
      component: () => import('@/components/AruddProcessingLogs.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/statementsOH',
      name: 'statementsOH',
      component: StatementsOH,
      meta: { requiresAuth: true },
    },
    {
      path: '/erroneous-transfers',
      name: 'erroneousTransfers',
      component: ETs,
      meta: { requiresAuth: true },
    },
    {
      path: '/on-hold-rules',
      name: 'onHoldRules',
      component: OnHoldRules,
      meta: { requiresAuth: true },
    },
    {
      path: '/dd-failure-charges',
      name: 'ddFailureCharges',
      component: () => import('@/components/FailedDdPaymentCharges.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/dd-failure-charges/new',
      name: 'newDdFailureCharge',
      component: () => import('@/components/EditFailedDdPaymentCharge.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/dd-failure-charges/:id',
      name: 'editDdFailureCharge',
      component: () => import('@/components/EditFailedDdPaymentCharge.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/manual-allocations-dashboard/:customerId',
      name: 'manualAllocationsDashboard',
      component: () => import('@/components/ManualAllocationDashboard.vue'),
      meta: { requiresAuth: true },
      beforeEnter: function (to, from, next) {
        // Feature switch guard — must use Vue.config (no component context in router)
        if (Vue.config.honeycomb && Vue.config.honeycomb.manualAllocations) {
          next()
        } else {
          next({ name: 'landingPage' })
        }
      }
    },
    {
      path: '/manual-allocations/:transactionId/allocations/:transactionType',
      name: 'manualAllocationsView',
      component: () => import('@/components/ManualAllocationView.vue'),
      meta: { requiresAuth: true },
      beforeEnter: function (to, from, next) {
        if (Vue.config.honeycomb && Vue.config.honeycomb.manualAllocations) {
          next()
        } else {
          next({ name: 'landingPage' })
        }
      }
    },
    {
      path: '/manual-allocations-dashboard/:customerReference/edit/:transactionId/allocations/:transactionType',
      name: 'manualAllocationsEdit',
      component: () => import('@/components/ManualAllocationView.vue'),
      meta: { requiresAuth: true },
      beforeEnter: function (to, from, next) {
        if (Vue.config.honeycomb && Vue.config.honeycomb.manualAllocations) {
          next()
        } else {
          next({ name: 'landingPage' })
        }
      }
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

// Add branding routes for development testing
addBrandingRoutes(router);

// //Nav guards
router.beforeEach((to, from, next) => {
  //Check for requiresAuth guard
  if (to.matched.some(record => record.meta.requiresAuth)) {
    //Check if NOT logged in
    if (!Vue.prototype.$auth || Vue.prototype.$auth.accessToken === null) {
      //Go to login
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      });
    }
    else {
      //Proceed to route
      next();
    }
  }
  else {
    // proceed to route
    next();
  }
});

export default router;
